import React, { useEffect } from "react";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../slices/common/reducer";
import { Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import CommonButton from "../../../../Components/Common/CommonButton/CommonButton";
import { OrganizationModalLayoutJSON } from "../Json/OrganizationLayoutJson";
import ConfirmationModal from "../Modal/ConfirmationModal";
import {
  getOrganizationData,
  updateOrganization,
} from "../OrganizationService";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";

const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigator = useNavigate();
  const data = useSelector(
    (state) => state.organization.selectedOrganization.detailsData
  );
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const editMode = !!params.id;

  const organizationFieldJson = useSelector(
    (state) => state.organization.organizationFieldsJson
  );
  const formState = useSelector((state) => state.common.formRendererState);

  // useEffect(() => {

  // }, []);

  useEffect(() => {
    getOrganizationData(params.id);
  }, []);

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    navigator("/org/org");
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const confirmUpdate = () => {
    if (formState.status) {
      dispatch(setSelectValidError(false));
      updateOrganization(formState, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  return (
    <div>
      <Form onSubmit={updateClickHandler}>
        <CardBody>
          <div className="selected-tab-bottom-content">
            {OrganizationModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, organizationFieldJson, formState)
                )}
              </div>
            ))}
          </div>
          <div className="form-footer">
            <CommonButton
              update={true}
              // handleSubmit={updateClickHandler}
              handleCancel={handleCancel}
              checkAccess={checkButtonAccess("EDIT", "ORG_ORG")}
            />
          </div>
          {verifyShow && <ConfirmationModal confirmUpdate={confirmUpdate} />}
        </CardBody>
      </Form>

      {/* </form> */}
    </div>
  );
};

export default Details;
